const adminPanelDictEN = {
  adminPanelSectionMain: "Main",
  adminPanelSectionSales: "Sales",
  adminPanelSectionCatalog: "Catalog",
  adminPanelSectionFinance: "Finance",
  adminPanelSectionStorefront: "Store & marketing",
  adminPanelUserLists: "User lists",
  adminPanelBanners: "Banners",
  adminPanelSearchMenu: "Search menu",
  adminPanelNoMenuResults: "No items found",
  adminPanelOpenMenu: "Open menu",
  adminPanelBeta: "Beta",
  adminPanelUseClassic: "Back to classic admin",
  adminPanelTryNew: "Try the new admin",
  adminPanelChooseTitle: "Which admin version do you want to use?",
  adminPanelChooseSubtitle:
    "We are moving the admin panel to a new design. Both versions have the same features.",
  adminPanelNewVersion: "New admin",
  adminPanelNewVersionDescription: "Modern look, menu grouped by area and quick search.",
  adminPanelClassicVersion: "Classic admin",
  adminPanelClassicVersionDescription: "The panel you already know, unchanged.",
  adminPanelChooseHint: "Your choice lasts until you log out. You can switch versions at any time using the button at the top of the screen.",

  // Home
  adminHomeNeedsAttention: "Needs attention",
  adminHomeNeedsAttentionHint: "Current pending items, regardless of the selected period",
  adminHomeAllClear: "All clear",
  adminHomePendingBankTransfers: "Bank transfers to confirm",
  adminHomePendingOrders: "Orders with issues",
  adminHomePendingWithdraws: "Withdrawals in processing",
  adminHomePendingBangood: "Unprocessed Bangood orders",
  adminHomePendingPhysicalStores: "Physical stores to verify",
  adminHomeIndicators: "Indicators",
  adminHomeCustomPeriod: "Custom period",
  adminHomeGroupRevenue: "Revenue",
  adminHomeGroupOperation: "Operations",
  adminHomeGroupWithdraws: "Withdrawals",
  adminHomeTotalUsers: "users in total",
  adminHomeTotalProducts: "products in total",

  // Listas de usuários
  adminUsersStatusAll: "All",
  adminUsersStatusActive: "Active",
  adminUsersStatusBlocked: "Blocked",
  adminUsersStatusCancelled: "Cancelled",
  adminUsersStatusFilter: "Filter by status",
  adminUsersSearchPlaceholder: "Search by name, username, email, phone or referrer",
  adminUsersCreatedBetween: "Sign-up date",
  adminUsersClearFilters: "Clear filters",
  adminUsersResults: "result(s)",
  adminUsersUser: "User",
  adminUsersContact: "Contact",
  adminUsersLoadError: "Could not load users.",
  adminUsersRetry: "Try again",
  adminUsersNoResults: "No users match these filters.",
  adminUsersEmpty: "No users registered in this list.",

  // Listas e filas
  adminListCopy: "Copy",
  adminListCopied: "Copied!",
  adminListLoadError: "Could not load the list.",
  adminListNoResults: "No items match this search.",
  adminListEmpty: "No items in this list.",
  adminWithdrawDestination: "Destination",
  adminWithdrawNoPending: "No withdrawals waiting to be processed.",
  adminBankTransferSearch: "Search by username or plan",
  adminBankTransferPending: "pending",
  adminBankTransferNone: "No transfers waiting for confirmation.",
  adminBankTransferConfirmMessage: "Confirm receipt of this transfer and activate the user's registration?",
  adminBankTransferAuthorized: "Transfer authorized successfully!",

  // Pedidos e pendências
  adminOrdersOrder: "Order",
  adminOrdersItems: "item(s)",
  adminOrdersAwaitingShipment: "Awaiting shipment",
  adminOrdersSearchPlaceholder: "Search by order no., buyer, seller or store",
  adminPendingSearchPlaceholder: "Search by order no. or buyer",
  adminPendingDownloadReceipt: "Download receipt",
  adminPendingConfirmMessage: "Confirm that the bank transfer for this order was received?",
  adminWithdrawRequestedShort: "Requested",

  // Catálogo e formulários
  adminFormSave: "Save",
  adminFormTranslations: "Name in each language",
  adminFormRequired: "Required field",
  adminFormImageHint: "One image, up to {mb} MB",
  adminFormImageInvalid: "Choose an image file.",
  adminFormImageChoose: "Choose image",
  adminFormImageReplace: "Replace image",
  adminFormImageKeepCurrent: "Keep current image",
  adminFormImageRemove: "Remove",
  adminFormImageDrop: "or drag the image here",
  adminCatalogCategories: "Categories",
  adminCatalogSubcategories: "Subcategories",
  adminCatalogEditCategory: "Edit category",
  adminCatalogEditSubcategory: "Edit subcategory",
  adminCatalogEditBrand: "Edit brand",
  adminCatalogEditType: "Edit type",
  adminCatalogSaved: "Saved successfully!",
  adminCatalogSearchName: "Search by name in any language",
  adminCatalogSearchSubcategory: "Search by subcategory or category",
  adminCatalogViewInStore: "View in store",
  adminCatalogChooseCategory: "Choose the category",
  adminCatalogKind: "Item kind",
  adminCatalogService: "Service",
  adminCatalogProduct: "Product",
  adminCatalogChooseSubcategories: "Choose subcategories",
  adminCatalogAddSubcategories: "Add subcategories",
  adminCatalogLinkedSubcategories: "Already linked subcategories",
  adminCatalogLinkHint: "Existing links can't be removed here.",
  adminCatalogLinkFailed: "Saved, but some subcategories could not be linked. Edit the item to try again.",
  adminProductsSearch: "Search by no., title or seller",

  // Relatórios
  adminReportsThisMonth: "This month",
  adminReportsLastMonth: "Last month",
  adminReportsThisYear: "This year",
  adminReportsExportPdf: "Export PDF",
  adminReportsOrdersCount: "Orders in period",
  adminReportsPlatformRevenue: "Platform revenue",
  adminReportsOnHoldCount: "on hold",
  adminReportsSearchOrders: "Search by no., buyer, seller, tax ID or status",
  adminReportsOrderShort: "Order",
  adminReportsPaymentMethods: "Payment methods",
  adminReportsInvoices: "Invoices",
  adminReportsBuyerShort: "Buyer",
  adminReportsSellerShort: "Seller",
  adminReportsInvoicingOn: "On",
  adminReportsInvoicingOff: "Off",
  adminReportsSubscriptionsCount: "Subscriptions in period",
  adminReportsTotalPaid: "Total paid",
  adminReportsSearchSubscriptions: "Search by name, document, address or payment method",
  adminReportsWithdrawalsCount: "Withdrawals in period",
  adminReportsSearchWithdrawals: "Search by name, email, PayPal or IBAN",

  // Lojas físicas e Bangood
  adminStoresSearch: "Search by store, owner, address or tax ID",
  adminStoresApproveShort: "Approve",
  adminStoresClose: "Close",
  adminStoresRejectHint: "The reason will be sent to the store owner.",
  adminBangoodToProcess: "To process",
  adminBangoodProcessed: "Processed",
  adminBangoodNoPending: "No Bangood orders waiting to be processed.",

  // Endereços, inscrições pagas e integrações
  adminSubscriptionsSearch: "Search by name, username or plan",
  adminIntegrationsConfigured: "Configured",
  adminIntegrationsNotConfigured: "Not configured",
  adminIntegrationsLoadFailed: "Could not load the current configuration. Saving will replace it.",
  adminIntegrationsMetaDescription: "Sends store events to the Meta Pixel (Facebook and Instagram Ads).",
  adminIntegrationsGtmDescription: "Adds the Google Tag Manager container to the store pages.",
  adminIntegrationsGtmHint: "Container code, in the format GTM-XXXXXXX.",
  adminAddressMenu: "SendCloud addresses",
  adminAddressUserHint: "Choose the type and search by name, username, email or city.",
  adminAddressSearchUser: "Search user",
  adminAddressLoadingUsers: "Loading users…",
  adminAddressSendcloud: "SendCloud address",
  adminAddressLoadingAddresses: "Loading addresses…",
  adminAddressNotFound: "Address not in the list?",
  adminAddressRegisterOnSendcloud: "Register it on SendCloud",
  adminAddressLink: "Link address",
  adminAddressLinkTitle: "Link address",
  adminAddressConfirmMessage: "Link this SendCloud sender address to the user?",
  adminAddressLinked: "Address linked successfully!",

  // Banners
  adminBannersNew: "New",
  adminBannersDesktop: "Desktop",
  adminBannersMobile: "Mobile",
  adminBannersRatio: "ratio",
  adminBannersApplyTo: "Apply to",
  adminBannersAllLanguages: "All languages",
  adminBannersBothDevices: "desktop and mobile",
  adminBannersImages: "images",
  adminBannersVisible: "Visible in store",
  adminBannersHidden: "Hidden",
  adminBannersPreview: "Store preview",
  adminBannersRemoveMessage: "The banner will be removed when you save your changes.",
  adminBannersSubDelayHint: "The same time applies to all three sub banners.",
  adminBannersRatioHint: "Every chosen image is cropped to the ratio",
  adminBannersUnsaved: "Unsaved changes",
  adminBannersAllSaved: "All saved",
  adminBannersSaving: "Saving…",

  // Whitelabel
  subnetEditedSuccessfully: "Subnet updated successfully!",
  editSubnetData: "Edit subnet data",
  searchByUsernameNameOrEmail: "Search by username, name or email",
  selectManager: "Select a manager",
  noManagersFound: "No managers found",
  adminWhitelabelActive: "Active",
  adminWhitelabelInactive: "Inactive",
  adminWhitelabelSearch: "Search by name, description, owner or ID",
  adminWhitelabelTheme: "Theme",
  adminWhitelabelVisualIdentity: "Visual identity",
  adminWhitelabelFooter: "Store footer",
  adminWhitelabelFaviconHint: "Icon shown in the browser tab.",
  adminWhitelabelInvalidEmail: "Enter a valid email.",
  adminWhitelabelThemeEmpty: "Fill in at least one field to customize.",
  adminWhitelabelThemeSaved: "Theme customized successfully!",
  adminWhitelabelThemeSaveError: "Error customizing the theme.",
  adminWhitelabelThemeLoadError: "Error loading the current theme.",
};

export default adminPanelDictEN;
